// extracted by mini-css-extract-plugin
export default {"container":"CurveNameInfo_container__uMyQD","info":"CurveNameInfo_info__TMt-2"};